module.exports = __webpack_public_path__ + "assets/img/202109-3W.e4f76009.png";